export default __webpack_public_path__ + "static/media/CryptoBulls.3bb5a80d.png";